import { createApp } from 'vue';
import NefToWebpConverter from '../Components/NefToWebpConverter.vue';

const root = document.getElementById('nef-to-webp-converter');
if (root) {
  createApp(NefToWebpConverter).mount('#nef-to-webp-converter');
}
